import "./CompanyIntro.css";
import companyImage from "../../assets/companyPicture.jpg";
import bgRight from "../../assets/WechatIMG10.jpg";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const advantageList = [
  "Agile Supply Chain",
  "R&D Capabilities",
  "Finished Product Inspection",
  "Design-based Customization",
  "Competitive OEM Factory",
  "One-stop Procurement",
];

const CompanyIntro = () => {
  const navigate = useNavigate();

  return (
    <div
      className="companyIntroWrapper"
      style={{
        backgroundImage: `url(${bgRight})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="companyIntroInner">
        {/* 左侧图片 */}
        <div className="companyIntroImage">
          <img src={companyImage} alt="Company Overview" />
        </div>

        {/* 右侧文字内容 */}
        <div className="companyIntroText">
          <h3 className="companyIntroTitle">ABOUT NANWEI</h3>
          <h2 className="companyIntroName">
            NANWEI STONE (QUANZHOU) CO., LTD
          </h2>
          <p className="companyIntroDesc">
            <p>"Focus on Stone Crafts, Specializing in the Reuse of Stone Resources" is the motto of our founder,Changjing Huang.</p>
            <p>“Al SHl ZHE" is the brand of our stone crafts, it belongs to Nanwei Stone. Nanwei is a 35-year-oldfactory that initially started with granite. As we adapted to the changing times, we ventured intothe realm of high-quality handmade stone crafts in 2015. For the past 9 years, our primary focushas been on producing an extensive range of stone crafts, offering more than 1000 differenttypes. We are dedicated to fulfilling all clients requirements and preferences. Our strict qualitycontrol measures have become the standard operating procedure, encompassing every aspect ofour production, from the selection of raw materials to the final packaging stage.With a 5000 square meter factory base, we are proud to support a workforce of over 70 skilledworkers. Additionally, we have a showroom that allows clients to immerse themselves in theworld of stone.</p>
            <p>If you have any personal designs for sales, souvenirs, or decor, we warmly encourage you to shareyour thoughts with us. We will make every effort to bring your ideas to life.</p>
          </p>

          <div className="companyIntroButtons">
            <button className="btnPrimary" onClick={() => navigate('/AboutUs')}>READ MORE</button>
            <button className="btnOutline" onClick={() => navigate('/GetInTouch')}>CONTACT US</button>
          </div>

          <hr className="divider" />

          <div className="advantageList">
            <div className="advantageColumn">
              {advantageList.slice(0, 3).map((item, index) => (
                <div className="advantageItem" key={index}>
                  <CheckCircleOutlined className="antdCheckIcon" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
            <div className="advantageColumn">
              {advantageList.slice(3, 6).map((item, index) => (
                <div className="advantageItem" key={index}>
                  <CheckCircleOutlined className="antdCheckIcon" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyIntro;